import { Title } from '@angular/platform-browser';

export class HasTitle {
  protected constructor(protected titleService: Title) {}

  setTitle(title) {
    this.titleService.setTitle(`${title} - Spotlight`);
  }
}
